export default __webpack_public_path__ + "static/media/show-menu-arrow.4ff7e491.svg";